import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { UploadButton } from "@/components/UploadButton";
import { toast } from "sonner";

export default function AdminHotels() {
  const [items, setItems] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({
    name: "",
    location_type: "Makkah",
    rating: 5,
    image: "",
    description: "",
  });

  const loadData = async () => {
    try {
      const { data } = await api.get("/admin/master/hotels");
      setItems(data);
    } catch {
      toast.error("Gagal memuat data hotel");
    }
  };

  useEffect(() => {
    loadData();
  }, []);

const saveHotel = async () => {
  try {

    if (editingId) {
      await api.patch(
        `/admin/master/hotels/${editingId}`,
        form
      );

      toast.success("Hotel berhasil diperbarui");
    } else {
      await api.post(
        "/admin/master/hotels",
        form
      );

      toast.success("Hotel berhasil ditambahkan");
    }

    setForm({
      name: "",
      location_type: "Makkah",
      rating: 5,
      image: "",
      description: "",
    });

    setEditingId(null);

    loadData();

  } catch {
    toast.error("Gagal menyimpan hotel");
  }
};

  const deleteHotel = async (id) => {
    if (!window.confirm("Hapus hotel ini?")) return;

    try {
      await api.delete(`/admin/master/hotels/${id}`);
      toast.success("Hotel berhasil dihapus");
      loadData();
    } catch {
      toast.error("Gagal menghapus hotel");
    }
  };

const editHotel = (item) => {
  setEditingId(item.id);

  setForm({
    name: item.name || "",
    location_type: item.location_type || "Makkah",
    rating: item.rating || 5,
    image: item.image || "",
    description: item.description || "",
  });

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">
          Database Hotels
        </h1>
      </div>

      <div className="grid md:grid-cols-2 gap-3">

        <input
          className="border rounded px-3 py-2"
          placeholder="Hotel Name"
          value={form.name}
          onChange={(e) =>
            setForm({
              ...form,
              name: e.target.value
            })
          }
        />

        <select
          className="border rounded px-3 py-2"
          value={form.location_type}
          onChange={(e) =>
            setForm({
              ...form,
              location_type: e.target.value
            })
          }
        >
              <option value="Makkah">Makkah</option>
<option value="Madinah">Madinah</option>
<option value="Jeddah">Jeddah</option>
<option value="Taif">Taif</option>
<option value="Istanbul">Istanbul</option>
<option value="Bursa">Bursa</option>
<option value="Cappadocia">Cappadocia</option>
        </select>

        <input
          type="number"
          className="border rounded px-3 py-2"
          placeholder="Rating"
          value={form.rating}
          onChange={(e) =>
            setForm({
              ...form,
              rating: Number(e.target.value)
            })
          }
        />

<div className="space-y-2">
  <UploadButton
    label="Upload Hotel Image"
    onUploaded={(url) =>
      setForm({
        ...form,
        image: url,
      })
    }
  />

  {form.image && (
    <img
      src={form.image}
      alt="Hotel Preview"
      className="h-32 w-full object-cover rounded border"
    />
  )}
</div>
      </div>

      <textarea
        className="w-full border rounded px-3 py-2"
        rows={3}
        placeholder="Description"
        value={form.description}
        onChange={(e) =>
          setForm({
            ...form,
            description: e.target.value
          })
        }
      />

        <button
  onClick={saveHotel}
  className="bg-blue-600 text-white px-4 py-2 rounded"
>
  {editingId
    ? "Update Hotel"
    : "Tambah Hotel"}
</button>

{editingId && (
  <button
    onClick={() => {
      setEditingId(null);

      setForm({
        name: "",
        location_type: "Makkah",
        rating: 5,
        image: "",
        description: "",
      });
    }}
    className="ml-3 border px-4 py-2 rounded"
  >
    Batal
  </button>
)}
      
      <table className="w-full border">
        <thead>
          <tr className="bg-gray-100">
            <th className="border p-2">Name</th>
            <th className="border p-2">Type</th>
            <th className="border p-2">Rating</th>
            <th className="border p-2">Action</th>
          </tr>
        </thead>

        <tbody>
          {items.map((item) => (
            <tr key={item.id}>
              <td className="border p-2">
                {item.name}
              </td>

              <td className="border p-2">
                {item.location_type}
              </td>

              <td className="border p-2">
                {item.rating}
              </td>
              <td className="border p-2 space-x-3">

  <button
    onClick={() => editHotel(item)}
    className="text-blue-600"
  >
    Edit
  </button>

  <button
    onClick={() => deleteHotel(item.id)}
    className="text-red-600"
  >
    Hapus
  </button>

</td>

            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

